import { formatDateToString } from "../../../../utils/date";

export const getTasksListForUI = (dailyTasks, taskToSync) => {
  if (dailyTasks) {
    const currentDate = formatDateToString(new Date());
    return dailyTasks.map((task) => {
      const isCompleted =
        task.lastCompletedOn === currentDate || taskToSync.includes(task._id);
      return {
        emoji: task.emoji,
        title: task.title,
        popupText: task.streak,
        id: task._id,
        key: task._id + isCompleted,
        completed: isCompleted,
        data: { ...task },
      };
    });
  }
  return [];
};
